const initialChatState = {
  // Active discussion identification
  discussion: null,
  // New message composing window
  compose: '',
  // Set when list contains data, ready to be displayed
  enable: false,
  ready: false,
  // Currently loaded messages information
  minIdLoaded: null,
  maxIdLoaded: null,
  // Message range for which we have forced a display size compute
  // (using List recomputeRowHeights)
  minIdComputed: null,
  maxIdComputed: null,

  // Info from List's onRowsRendered
  overscanStartIndex: null,
  overscanStopIndex: null,
  startIndex: null,
  stopIndex: null,

  // List element controls
  scrollToIndex: undefined,
  rowCount: 0,

  // Info from List's onScroll
  // Dislpay div height
  clientHeight: null,
  // render div height (partially visible)
  scrollHeight: null,
  // display div top position inside render div
  scrollTop: null,

  // Max message Id for this discussion (might not be loaded), from 1 to X
  msgCnt: null,
  // True when user is currently following discussion last message:
  stickToLastMessage: true,
  // Avoid multiple fetching in parallel
  fetchHoldCnt: 0,
  // Re-center scroll after messages get loaded
  // Specify where to recenter
  scrollLockClientCnt: 0,

  // Set when we are recording an audio file
  audioPending: false,
  // Set when we are actively recording an audio file
  recordingAudio: false,
  // Set until the user releases the record audio button
  recordingAudioMouseKeptDown: false,
  // Set when the user is continuously holding down the audio record button
  //  to record audio
  recordingAudioMouseHold: false,
  recordingAudioMouseHoldValid: false,

  // Set when we are preparing a questionnaire
  questionPending: false,
  // Set when we are selecting the questionnaire
  questionSelecting: false,
  // Question code, and corresponding text
  questionId: undefined,
  questionText: '',
  // If needed, enable adding text to the standard question
  questionAddEnable: false,
  // Text added at the end of the question
  questionAdd: '',
  // Full question (for rendering)
  questionCompose: '',
};

const chatStateReducer = (state, action) => {
  switch (action.type) {
    case 'reset': {
      // console.log('chatStateReducer reset');
      if (!action.enable) return ({ ...initialChatState });

      if (action.discussion
         && state.enable
         && (action.discussion === state.discussion)) return state;

      if (action.discussion && (action.discussion !== state.discussion)) {
        return ({
          ...initialChatState,
          discussion: action.discussion,
          enable: action.enable,
        });
      }

      return ({ ...initialChatState });
    }

    case 'info': {
      if (!state.enable) {
        console.log('CaseChat not enabled, ignore info action');
        return state;
      }
      if (state.ready && (action.msgCnt === state.msgCnt)) {
        // console.log('!!! repeat information !!!');
        return state;
      }
      // console.log(`chatStateReducer action=${JSON.stringify(action, 2)}`);
      // Relevant information, go fetch initial messages
      return ({
        ...state,
        msgCnt: action.msgCnt,
        ready: true,
      });
    }

    case 'sent': {
      if (action.msgCnt <= state.msgCnt) {
        console.log('!!! sent incoherent id? !!!');
        return state;
      }
      // Relevant information, go fetch initial messages
      // console.log(`Sent, now msgCnt=${action.msgCnt}, maxIdLoaded=${state.maxIdLoaded}`);
      return ({
        ...state,
        msgCnt: action.msgCnt,
        audioPending: false,
        recordingAudio: false,
        questionPending: false,
        questionSelecting: false,
      });
    }

    case 'load': {
      // New data loaded
      // console.log(`chatStateReducer action=${JSON.stringify(action, 2)}`);
      if (!action.msgCnt) {
        console.log(`!!! invalid load data, action=${
          JSON.stringify(chatStateReducer, null, 2)}`);
        return state;
      }
      if (!state.enable) {
        console.log('CaseChat not enabled, ignore load action');
        return state;
      }

      const newMaxIdLoaded = (action.newMaxIdLoaded && (action.newMaxIdLoaded > state.maxIdLoaded))
        ? action.newMaxIdLoaded
        : (state.maxIdLoaded || action.newMaxIdLoaded);

      const newScrollToIndex = (newMaxIdLoaded && state.stickToLastMessage)
        ? (newMaxIdLoaded - 1)
        : undefined;

      const newState = {
        ...state,
        ready: !!(action.newMaxIdLoaded),
        minIdLoaded: (action.newMinIdLoaded && (action.newMinIdLoaded < state.minIdLoaded))
          ? action.newMinIdLoaded
          : (state.minIdLoaded || action.newMinIdLoaded),
        maxIdLoaded: newMaxIdLoaded,
        msgCnt: action.msgCnt || state.msgCnt,
        scrollToIndex: newScrollToIndex,
        rowCount: newMaxIdLoaded,
      };

      return (newState);
    }

    case 'scroll': {
      // console.log(`scroll action=${JSON.stringify(action)}`);
      // console.log(`scroll action=${JSON.stringify(action)
      // }, stopIndex=${state.stopIndex
      // }, msgCnt=${state.msgCnt}`);
      // Figure out if we scrolled to the list's bottom and/or top

      // Update stickToLastMessage ONLY if we haven't locked the scroll position
      // (for instance when fetching new messages)
      const newStickToLastMessage = (state.scrollLockClientCnt)
        ? state.stickToLastMessage
        : ((action.scrollHeight <= (action.clientHeight + action.scrollTop + 1))
            && (state.stopIndex === (state.msgCnt - 1)));

      if ((state.clientHeight === action.clientHeight)
        && (state.scrollHeight === action.scrollHeight)
        && (state.scrollTop === action.scrollTop)
        && (state.stickToLastMessage === newStickToLastMessage)) {
        return state;
      }

      const newScrollToIndex = (state.maxIdLoaded && newStickToLastMessage)
        ? (state.maxIdLoaded - 1)
        : undefined;

      return ({
        ...state,
        clientHeight: action.clientHeight,
        scrollHeight: action.scrollHeight,
        scrollTop: action.scrollTop,
        stickToLastMessage: newStickToLastMessage,
        scrollToIndex: newScrollToIndex,
      });
    }

    case 'rendered': {
      // console.log(`rendered action=${JSON.stringify(action)}`);
      // }, scrollLockClientCnt=${state.scrollLockClientCnt
      // }, stickToLastMessage=${state.stickToLastMessage}`);

      return ({
        ...state,
        overscanStartIndex: action.overscanStartIndex,
        overscanStopIndex: action.overscanStopIndex,
        startIndex: action.startIndex,
        stopIndex: action.stopIndex,
      });
    }

    case 'lockScroll': {
      // console.log(`lockScroll - new scrollLockClientCnt=${
      //   state.scrollLockClientCnt + 1}`);
      return ({
        ...state,
        scrollLockClientCnt: state.scrollLockClientCnt + 1,
      });
    }

    case 'endLockScroll': {
      if (state.scrollLockClientCnt === 0) {
        console.log(`Error!!! endLockScroll\naction=${JSON.stringify(action)
        }\nstate=${JSON.stringify(state, null, 2)}`);
        return state;
      }
      // console.log(`endLockScroll - new scrollLockClientCnt=${
      //   state.scrollLockClientCnt - 1}`);
      return ({
        ...state,
        scrollLockClientCnt: state.scrollLockClientCnt - 1,
      });
    }

    case 'compose':
      // console.log(`compose action=${JSON.stringify(action)
      // }, compose="${state.compose}"`);
      if (action.discussion) {
        if (state.compose === action.value) return state;
        return ({ ...state, compose: action.value });
      }
      // No discussion, clear compose
      if (state.compose === '') return state;
      return ({ ...state, compose: '' });

    case 'clearCompose':
      if ((state.compose === '')
        && (state.questionCompose === '')) return state;
      return ({
        ...state,
        compose: '',
        questionCompose: '',
        questionAdd: '',
      });

    case 'renderedUpTo': {
      if ((action.newMinIdComputed === state.minIdComputed)
      && (action.newMaxIdComputed === state.maxIdComputed)
      ) return state;
      // console.log(`Render was (${state.minIdComputed},${state.maxIdComputed}), now (${
      //   action.newMinIdComputed || state.minIdComputed},${
      //   action.newMaxIdComputed || state.maxIdComputed})`);
      return ({
        ...state,
        minIdComputed: action.newMinIdComputed || state.minIdComputed,
        maxIdComputed: action.newMaxIdComputed || state.maxIdComputed,
      });
    }

    case 'fetchHold': {
      // console.log(`New fetchHoldCnt=${state.fetchHoldCnt + 1}`);
      return ({
        ...state,
        fetchHoldCnt: state.fetchHoldCnt + 1,
      });
    }

    case 'endFetchHold': {
      if (state.fetchHoldCnt === 0) {
        console.log(`Error!!! endFetchHold\naction=${JSON.stringify(action)
        }\nstate=${JSON.stringify(state, null, 2)}`);
        return state;
      }
      // console.log(`New fetchHoldCnt=${state.fetchHoldCnt - 1}`);
      return ({
        ...state,
        fetchHoldCnt: state.fetchHoldCnt - 1,
      });
    }

    case 'audioMouse':
      // console.log(`chatStateReducer action=${JSON.stringify(action, null, 2)}`);
      if (state.recordingAudio) {
        switch (action.mouseEvent) {
          case 'mouseup':
            if (!state.recordingAudioMouseHoldValid) {
              return {
                ...state,
                recordingAudioMouseKeptDown: false,
              };
            }
            return {
              ...state,
              recordingAudio: false,
            };

          case 'mousedown':
            if ((!state.recordingAudioMouseHoldValid)
              || (!state.recordingAudioMouseHold)) {
              // Quick double click
              //  or record controlled via click
              return {
                ...state,
                recordingAudio: false,
              };
            }
            return state;

          default: return state;
        }
      } else {
        if (action.mouseEvent === 'mousedown') {
          return {
            ...state,
            audioPending: true,
            recordingAudio: true,
            recordingAudioMouseKeptDown: true,
            recordingAudioMouseHoldValid: false,
          };
        }

        return state;
      }

    case 'audioHoldTimeout':
      if (state.recordingAudio && (!state.recordingAudioMouseHoldValid)) {
        return {
          ...state,
          recordingAudioMouseHold: state.recordingAudioMouseKeptDown,
          recordingAudioMouseHoldValid: true,
        };
      }
      return state;

    // Fired by CaseChat.jsx audioMaxDurationMs timer; stops like a hold-release, keeping audioPending for review/send
    case 'audioMaxDuration':
      if (state.recordingAudio) {
        return {
          ...state,
          recordingAudio: false,
        };
      }
      return state;

    case 'cancelAudioQuestion':
      if (state.audioPending) {
        return {
          ...state,
          audioPending: false,
          recordingAudio: false,
        };
      }
      if (state.questionPending) {
        return {
          ...state,
          questionPending: false,
          questionSelecting: false,
          questionId: undefined,
          questionText: '',
          questionAdd: '',
          questionCompose: '',
          questionAddEnable: false,
        };
      }
      return state;

    case 'openQuestion':
      if (!state.questionPending) {
        return {
          ...state,
          questionPending: true,
          questionSelecting: true,
          questionId: undefined,
          questionText: '',
          questionAdd: '',
          questionCompose: '',
          questionAddEnable: false,
        };
      }
      return state;

    case 'setQuestion':
      if (state.questionPending) {
        return {
          ...state,
          questionId: action.questionId,
          questionSelecting: false,
          questionText: `${action.text}`,
          questionCompose: (action.addTextEnable)
            ? `${action.text} `
            : action.text,
          questionAdd: '',
          questionAddEnable: action.addTextEnable,
        };
      }
      return state;

    case 'composeQuestion':
      if (action.discussion) {
        if (!state.questionPending) return state;
        if (!state.questionAddEnable) return state;
        if (!action.value.startsWith(`${state.questionText} `)) {
          return state;
        }
        const newQuestionAdd = action.value.replace(
          state.questionText,
          '',
        ).trim();

        return ({
          ...state,
          questionCompose: action.value,
          questionAdd: newQuestionAdd,
        });
      }
      // No discussion, clear compose
      if (state.questionCompose === '') return state;
      return ({ ...state, questionCompose: '' });

    default:
      throw new Error(`chatStateReducer action=${JSON.stringify(action, null, 2)}`);
  }
};

export { chatStateReducer };
export { initialChatState };
